import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V6c0-.55.45-1 1-1h8c.55 0 1 .45 1 1v12z"
}), 'TurnedInNotRounded');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/TurnedInNotRounded.js
// module id = 6947
// module chunks = 2